export const TechnicalSolutionsFlags = {
  PrismMobileHotReleasee: 'pmo-integrations-prism-mobile-hot-release-2023-06',
  PrismWorkOrder: 'pmo-integrations-prism-work-orders',
  PrismVisitorManagement: 'pmo-integrations-prism-visitor-management',
  EnableSSOAndMultiBuildingForBE: 'squad-technical-solutions.be-prism-auth-sso-multi-building-support',
  WebHookNotificationForBE: 'squad-technical-solutions.be-prism-webhook-notification',
  PhoneNumberReqForSignup: 'squad-technical-solutions.phone-number-req-for-signup',
  UseLibPhoneNumberVerificationFlow: 'squad-technical-solutions.use-lib-phone-number-verification-flow',
  EnableSwireSignupFlow: 'squad-technical-solutions.enable-swire-signup-flow',
  UseSwirePacificPlaceOfficeAppDefault: 'squad-technical-solutions.use-swire-pacific-place-office-default-app',
  EnableVantifyIntegration: 'squad-technical-solutions.vantify-integration',
  VantifyAuthToken: 'squad-technical-solutions.vantify-auth-token',
  VantifyTokenOptimization: 'squad-technical-solutions.vantify-token-optimization',
  OnboardingMergeBuildingAndCompany: 'squad-technical-solutions.onboarding-merge-building-and-company',
  CompanySelectionRequiredDuringSignup: 'squad-technical-solutions.company-selection-required-during-onboarding',
  // Rogue flags
  SquadTechnicalSolutionsBuildingEngineTokenManagement: 'squad-technical-solutions.building-engine-token-management',
  SquadTechnicalSolutionsPhoneNumberCollectionForWhitelabel: 'squad-technical-solutions.phone-number-collection-for-whitelabel',
  SquadTechnicalSolutionsUseLegacyPhoneNumberVerificationFlow: 'squad-technical-solutions.use-legacy-phone-number-verification-flow',
  SquadTechnicalSolutionsUsePhoneNumberVerificationLib: 'squad-technical-solutions.use-phone-number-verification-lib',
  SquadTechnicalSolutionsEnableDsxUdf: 'squad-technical-solutions.enable-dsx-refactor-udf',
  SquadTechnicalSolutionsWebHookNotificationForVantify: 'squad-technical-solutions.vantify-webhook-notification',
  SquadTechnicalSolutionsEnableAnalyticContentTouchPhone: 'squad-technical-solutions.analytic-content-touch-phone',

  // Rogue flags end
} as const;
